export const biling =
{
  path: '/biling-payment',
  name: 'tagihanBiling',
  hidden: true,
  component: () => import('@/components/biling/components/payment-biling'),
  meta: {
    title: 'Upload Bukti Pembayaran',
    icon: 'fa-book',
    roles: ['administrator', 'member']
  },
}
export default biling



// WEBPACK FOOTER //
// ./src/router/modules/formPaymentBiling.js